import * as React from "react";
import { useState } from "react";
import { CSSProperties } from "styled-components";

import { CancelTextWrapper, CancelButtonWrapper, CloseIconWrapper, StyledHeaderActionsIcon } from "./StyledComponents";

export interface CloseButtonProps {
    onClick: () => void;
    hintText: string;
    style?: CSSProperties;
    "data-testid"?: string;
}

const CloseButton: React.FC<CloseButtonProps> = (props) => {
    const [isHovering, setIsHovering] = useState(false);

    const handleMouseEnter = () => {
        setIsHovering(true);
    };
    const handleMouseLeave = () => {
        setIsHovering(false);
    };

    return (
        <CancelButtonWrapper style={props.style}>
            <CloseIconWrapper
                data-testid={props["data-testid"]}
                onClick={props.onClick}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <StyledHeaderActionsIcon name={"close"} />
                {isHovering && <CancelTextWrapper>{props.hintText}</CancelTextWrapper>}
            </CloseIconWrapper>
        </CancelButtonWrapper>
    );
};

export default CloseButton;
